import { Component, OnInit, Input, forwardRef, NgModule, TemplateRef, Output, EventEmitter, ViewChild, ViewContainerRef, ElementRef, ContentChild, SimpleChange } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule, NgForOfContext } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { Subject } from 'rxjs/Rx';
import { ApiService } from '../services/api.service';

export interface Shipper {
    name: string;
    code: string;
    idBak?: string;
    mobile?: string;
    disabled?: boolean;
}

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ShipperSelectComponent),
    multi: true
};
export class ShipperSelectComponent implements ControlValueAccessor, OnInit {
private onTouchedCallback: () => () => {};
private onChangeCallback: (_: any) => () => {};

    options: Array<Shipper> = [];
    // 单选的时候传字符串，多选传数组
    _value: string;
    _width = "100%";
    _content: TemplateRef<any>;
    _allowClear = true;
    _nzMode = "combobox";
    // 下拉过滤含关键字选项，false为不过滤
    _filter = false;
    currentText = '';
    canQuery = true;
    keyWordStream = new Subject<string>()
    keyWord$: any;
    firstNum = 1;
    loading = false;

     userCode = "";
     placeholder = "请输入发货人";
     rowsNum = 10;
     valueType = "";
     protocolType = "";
     yztDisabled = false;
/**
 * @param {?} v
 * @return {?}
 */
set value(v: any) {
        if (typeof v === 'string' && v.trim() === '' || !v) {
            this.canQuery = true;
            this.firstNum = 1;
            this.options = [];
            this.currentText = '';
            this.userCode = '';
            this.queryData('', []);
            this.onChangeCallback(null);
            return;
        }
        this._value = v;
        // 双向绑定获取对象
        if (this.valueType === "object") {
            const { consignorCode, name } = v;
            this.onChangeCallback({ value: consignorCode, label: name });
        } else if (this.valueType === "fullObject") {
            this.onChangeCallback(v);
        } else if (this.valueType === "name") {
            this.onChangeCallback(v.name);
        } else {
            this.onChangeCallback(v.userCode);
        }
    }
/**
 * @return {?}
 */
get value(): any {
        return this._value;
    };
/**
 * @param {?} v
 * @return {?}
 */
set width(v: any) {
        const /** @type {?} */ width = parseInt(v);
        this._width = ( /** @type {?} */((<any>Array.from(v)))).includes("%") ? `${v}%` : isNaN(width) ? this._width : `${width}px`;
    }
/**
 * @param {?} v
 * @return {?}
 */
set OptionMode(v) {
        this._nzMode = v;
        this._allowClear = v === "combobox" ? true : false;
    };
/**
 * @param {?} tpl
 * @return {?}
 */
set customTemplate(tpl: TemplateRef<any>) {
        if (tpl instanceof TemplateRef) {
            this._content = tpl;
        }
    }

     nzOpenChange: EventEmitter<any> = new EventEmitter();
     outOptions: EventEmitter<any> = new EventEmitter();
/**
 * @param {?} api
 */
constructor(private api: ApiService) {
    }
/**
 * @return {?}
 */
ngOnInit() {
        // 限流
        this.keyWord$ = this.keyWordStream
            .debounceTime(250)
            .subscribe(word => {
                this.queryData(word, [])
            });
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: any) {
        if (changes.userCode && this.userCode) {
            this.firstNum = 1;
            this.loading = true;
            this.canQuery = true;
            this.queryData(this.userCode, [], true);
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.keyWord$.unsubscribe()
    }
/**
 * @param {?} event
 * @return {?}
 */
yztSearchChange(event) {
        this.canQuery = true;
        this.currentText = event;
        this.firstNum = 1;
        this.keyWordStream.next(event);
    }
/**
 * @return {?}
 */
yztScrollToBottom() {
        this.queryData(this.currentText, this.options);
    }
/**
 * @param {?} event
 * @return {?}
 */
yztOpenChange(event) {
        this.nzOpenChange.emit(event)
    }
/**
 * 仅作清空多选选项
 * @param {?=} $event
 * @return {?}
 */
clearSelect($event?: MouseEvent): void {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        this.options = [];
        this.value = '';
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this._value) {
            this._value = value;
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * 查询数据
 * @param {?=} searchText
 * @param {?=} options
 * @param {?=} firstIn
 * @return {?}
 */
queryData(searchText?: string, options?: Array<Shipper>, firstIn: boolean = false) {
        if (!this.canQuery) return;
        const /** @type {?} */ shipperName = searchText;
        let /** @type {?} */ params;
        if (this.userCode) {
            params = [{ "page": this.firstNum, "size": this.rowsNum }, { key: this.userCode }];
        } else {
            params = [{ "page": this.firstNum, "size": this.rowsNum }, { key: shipperName, protocolType: this.protocolType }];
        }
        this.api.getConsignorList( /** @type {?} */((params as any))).subscribe(json => {
            let /** @type {?} */ content = json && json['content'] || {};
            let /** @type {?} */ result = content['content'] || []

            this.options = options.concat(result);
            this.firstNum += 1;
            if (firstIn || this.userCode) {
                this.value = this.options[0];
            }
            this.loading = false;

            if (result.length < this.rowsNum) {
                this.options.push({ code: "empty", name: "没有更多选项！", disabled: true });
                this.canQuery = false;
            }
        })
    }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: `yzt-shipper`,
    template: `
    <div class="shipper-select">
        <nz-select 
            class="shipper-nz-select"
            [style.width]="_width" 
            [nzPlaceHolder]="placeholder" 
            [nzMode]="_nzMode"
            [nzFilter]="_filter"
            [nzAllowClear]="_allowClear"
            (nzSearchChange)="yztSearchChange($event)"
            (nzScrollToBottom)="yztScrollToBottom()"
            (nzOpenChange)="yztOpenChange($event)"
            [nzDisabled]="yztDisabled"
            [(ngModel)]="value">
            <nz-option
                *ngFor="let option of options"
                [nzLabel]="option.name"
                [nzValue]="option"
                [nzDisabled]="option.disabled">
                <ng-template *ngIf="_content" #nzOptionTemplate>
                    <ng-container #nzOptionCon [ngTemplateOutlet]="_content" [ngTemplateOutletContext]="option"></ng-container>
                </ng-template>
            </nz-option>
        </nz-select>
        <span
          role="close-icon"
          (click)="clearSelect($event)"
          class="ant-select-selection__clear close-icon"
          style="-webkit-user-select: none;"
          *ngIf="!_allowClear&&options.length">
        </span>
    </div>
    `,
    styles: [`
    .shipper-select{
        position: relative;
    }
    .close-icon {
        opacity: 0;
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -10px;
    }
    .close-icon:hover {
        opacity: 1;
    }
    .shipper-nz-select:hover +.close-icon {
        opacity: 1;
    }
    :host ::ng-deep .ant-select-disabled .ant-select-selection {
        background: #f0f0f0;
        color: #2b2b2b;
    }
    `],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApiService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'userCode': [{ type: Input },],
'placeholder': [{ type: Input },],
'rowsNum': [{ type: Input },],
'valueType': [{ type: Input },],
'protocolType': [{ type: Input },],
'yztDisabled': [{ type: Input },],
'width': [{ type: Input },],
'OptionMode': [{ type: Input },],
'customTemplate': [{ type: Input },],
'nzOpenChange': [{ type: Output },],
'outOptions': [{ type: Output },],
};
}

function ShipperSelectComponent_tsickle_Closure_declarations() {
/** @type {?} */
ShipperSelectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ShipperSelectComponent.ctorParameters;
/** @type {?} */
ShipperSelectComponent.propDecorators;
/** @type {?} */
ShipperSelectComponent.prototype.onTouchedCallback;
/** @type {?} */
ShipperSelectComponent.prototype.onChangeCallback;
/** @type {?} */
ShipperSelectComponent.prototype.options;
/** @type {?} */
ShipperSelectComponent.prototype._value;
/** @type {?} */
ShipperSelectComponent.prototype._width;
/** @type {?} */
ShipperSelectComponent.prototype._content;
/** @type {?} */
ShipperSelectComponent.prototype._allowClear;
/** @type {?} */
ShipperSelectComponent.prototype._nzMode;
/** @type {?} */
ShipperSelectComponent.prototype._filter;
/** @type {?} */
ShipperSelectComponent.prototype.currentText;
/** @type {?} */
ShipperSelectComponent.prototype.canQuery;
/** @type {?} */
ShipperSelectComponent.prototype.keyWordStream;
/** @type {?} */
ShipperSelectComponent.prototype.keyWord$;
/** @type {?} */
ShipperSelectComponent.prototype.firstNum;
/** @type {?} */
ShipperSelectComponent.prototype.loading;
/** @type {?} */
ShipperSelectComponent.prototype.userCode;
/** @type {?} */
ShipperSelectComponent.prototype.placeholder;
/** @type {?} */
ShipperSelectComponent.prototype.rowsNum;
/** @type {?} */
ShipperSelectComponent.prototype.valueType;
/** @type {?} */
ShipperSelectComponent.prototype.protocolType;
/** @type {?} */
ShipperSelectComponent.prototype.yztDisabled;
/** @type {?} */
ShipperSelectComponent.prototype.nzOpenChange;
/** @type {?} */
ShipperSelectComponent.prototype.outOptions;
/** @type {?} */
ShipperSelectComponent.prototype.api;
}

export class ShipperSelectModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule,
    ],
    declarations: [
        ShipperSelectComponent
    ],
    exports: [ShipperSelectComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ShipperSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
ShipperSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ShipperSelectModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
